module.exports = __webpack_public_path__ + "img/ring_skip_skip_0_0@3x.6f511a05.png";